import classNames from 'classnames'
import React from 'react'

import * as styles from './LoadingSpinner.less'

export default props => {
  const {className, ...restProps} = props
  return <div className={classNames(styles.loader, className)} {...restProps} />
}
